import type {Pointer, PS} from '@wix/document-services-types'
import _ from 'lodash'
import constants from '../../constants/constants'

function getLayoutLimits(ps: PS, repeaterPointer: Pointer) {
    const itemPointer = _.head(ps.pointers.full.components.getChildren(repeaterPointer))
    const itemLayout = itemPointer && ps.dal.full.get(ps.pointers.getInnerPointer(itemPointer, ['layout']))
    return {
        minWidth: _.get(itemLayout, 'width')
    }
}

export default {
    layoutLimits: getLayoutLimits,
    canBeStretched: true,
    resizableSides: [constants.RESIZE_SIDES.LEFT, constants.RESIZE_SIDES.RIGHT],
    mobileConversionConfig: {
        filterChildrenWhenHidden: true,
        stretchHorizontally: true
    }
}
